import { Result, ResultOf } from '@/types/result';
import { ApiService } from './ApiService';
import { ParticipantSelect, TimeSlotsRequestModel, TimeSlotsResponseModel } from '../pages/LessonModal/types/interfaces';
import { TimeTable } from '@/types/TimeTable';
import { CurrencyType } from '@/types/CurrencyType';
import { DataSelect } from '@/types/DataSelect';
import { RespondToSurveyRequest } from '../pages/Survey/types/interfaces';
import { StudentCardInfo } from '@/pages/Onboarding/types/StudentCardInfo';

export class TeacherApi extends ApiService {
    base = 'Teacher';

    async getTimeSlots(params: TimeSlotsRequestModel): Promise<ResultOf<TimeSlotsResponseModel>> {
        return await this
            .get(this.getUrl('GetTimeSlots'), params as unknown as Record<string, string>);
    }

    async getNonWorkDays(): Promise<ResultOf<{
        nonWorkDays: Array<number>;
    }>> {
        return await this.get(this.getUrl('GetNonWorkDaysForCurrent'));
    }

    async getNonWorkDaysForTeacher(teacherId: number | string): Promise<ResultOf<{
        nonWorkDays: Array<number>;
    }>> {
        return await this.get(this.getUrl('GetNonWorkDaysForTeacher'), {teacherId});
    }

    async getStudents(): Promise<ParticipantSelect[]> {
        const result: ResultOf<{ studentCardInfos: StudentCardInfo[] }> = await this.get(this.getUrl('Students'));
        const studentCardInfos = result.entity?.studentCardInfos ?? [];
        const res = studentCardInfos.map(({ studentCardId, name, currencyType }) => ({id: studentCardId, name, currencyType }));
        return res;
    }

    async getGroups() {
        const result: ResultOf<{groupInfos: DataSelect[]}> = await this.get(this.getUrl('Groups'));
        return result.entity?.groupInfos ?? [];
    }

    async getTimeTable(): Promise<ResultOf<{
        teacherId: number,
        timeTable: TimeTable,
    }>> {
        return await this.get(this.getUrl('GetTimeTable'));
    }

    async getEditTimeTable(id: number | string): Promise<ResultOf<{
        teacherId: number;
        timeTable: TimeTable;
    }>> {
        const params = {
            teacherId: id,
        };
        return await this.get(this.getUrl('EditTimeTable'), params);
    }

    async postEditTimeTable(model: {
        teacherId: number;
        timeTable: TimeTable;
    }): Promise<Result> {
        return await this.post(this.getUrl('EditTimeTable'), model);
    }

    async SaveTimeTable(model: {
        teacherId: number;
        timeTable: TimeTable;
    }): Promise<Result> {
        return await this.post(this.getUrl('EditTimeTable'), model);
    }

    async getCurrentTeacherTariffInfo(): Promise<ResultOf<{
        hasProTariff: boolean;
        hasUnlimitedStudents: boolean;
        studentCardsCount: number;
        baseTariffMaxStudentCount: number;
        isOnPause: boolean;
        pauseReturnDeadline: string | null;
    }>> {
        return await this.get(this.getUrl('GetCurrentTeacherTariffInfo'));
    }

    async setMainCurrencyAndTimeZone(type: CurrencyType, zone: string | null): Promise<Result> {
        return await this.post(this.getUrl('SetMainCurrencyAndTimeZone'), {type, zone}, true);
    }

    async getMainCurrency(): Promise<ResultOf<CurrencyType>> {
        return await this.get(this.getUrl('GetMainCurrency'));
    }

    async RespondToSurvey(model: RespondToSurveyRequest): Promise<Result> {
        return await this.post(this.getUrl('RespondToSurvey'), model);
    }
}
